import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { DeeplinkOpenComponent } from './modules/deeplink-open/deeplink-open.component';
import { DeeplinkComponent } from './modules/deeplink/deeplink.component';
import { SwapWifi6Component } from './modules/swap-wifi-6/swap-wifi.component';
import { IntroduceWifi6Component } from './modules/introduce-wifi6/introduce-wifi6.component';
import { DeleteAccountComponent } from './modules/delete-account/delete-account.component';
import { HealthComponent } from './modules/health/health.component';
import { LandingPageUtilitiesComponent } from './modules/landing-page-utilities/landing-page-utilities.component';
import { ListContractComponent } from './modules/list-contract/list-contract.component';
import { ResultPaymentComponent } from './modules/result-payment/result-payment.component';
import { VietQRComponent } from './modules/viet-qr/viet-qr.component';
import { CompareWifi6Component } from './modules/compare-wifi6/compare-wifi6.component';
import {LinkComponent} from "./modules/link/Link.component";
import {DeeplinkPreviewComponent} from "./modules/deeplink-preview/deeplink.component";
import {DeeplinkNewComponent} from "./modules/deeplink-new/deeplink.component";
import { SwapWifiComponent } from './modules/swap-wifi/swap-wifi.component';

const routes: Routes = [
  { path: 'health', component: HealthComponent },
  // { path: 'doc', loadChildren: () => import('projects/document/src/app/app.module').then((m) => m.DocSharedModule)  },
  { path: '', component: DeeplinkComponent },
  { path: 'preview', component: DeeplinkPreviewComponent },
  { path: 'preview/:enc', component: DeeplinkPreviewComponent },
  { path: 't', component: DeeplinkNewComponent },
  { path: 't/:screen/:code', component: DeeplinkNewComponent },
  { path: 'deeplink', component: DeeplinkOpenComponent },
  { path: 'link', component: LinkComponent },
  {
    path: ':screen/:code',
    component: DeeplinkComponent,
  },
  {
    path: 'swap-wifi-6',
    component: SwapWifi6Component,
  },
  {
    path: 'swap-wifi',
    component: SwapWifiComponent,
  },
  {
    path: 'about-wifi-6',
    component: IntroduceWifi6Component,
  },
  {
    path: 'compare-wifi-6',
    component: CompareWifi6Component,
  },
  {
    path: 'delete-account',
    component: DeleteAccountComponent,
  },
  {
    path: 'landing-page-utilities',
    component: LandingPageUtilitiesComponent,
  },
  {
    path: 'list-contract',
    component: ListContractComponent,
  },
  {
    path: 'result-payment',
    component: ResultPaymentComponent,
  },
  {
    path: 'viet-qr',
    component: VietQRComponent,
  },
  // {
  //   path: 'ftel-contract',
  //   component: FtelContractComponent,
  // },
  // {
  //   path: 'redirect',
  //   component: RedirectComponent,
  // },
];
const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
};
@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
